import { action, extend, register } from "@gadgetinc/mobx-quick-tree";
import { EnvironmentNameMSTType, type LegacyEnvironmentName } from "../../Environment";
import { contentHash } from "../../utils";
import { ShopifyBaseAdminAppConfig } from "./ShopifyBaseAdminAppConfig";

/**
 * See packages/state-trees/src/connections/ShopifyConnectionConfig.ts for documentation
 * on the different types of Shopify configurations
 */
@register
export class ShopifyLegacyAdminAppConfig extends extend(ShopifyBaseAdminAppConfig("ShopifyManualAppConfig"), {
  environment: EnvironmentNameMSTType,
}) {
  get contentHash() {
    return contentHash([this.apiKey, this.apiSecretKey, this.environment, this.shopDomain, this.accessToken]);
  }

  @action
  setEnvironment(value: LegacyEnvironmentName) {
    this.environment = value;
  }
}
